import React from 'react'
import LifeYoungItem from './item.js'
import styles from './index.module.scss'

function LifeYoung ({list, current}) {
    const getCurrent = (index) => {
        current(index)
    }
    return (
        <ul className={`lifeYoung ${styles.lifeYoung}`}>
            <LifeYoungItem list={list} current={getCurrent}></LifeYoungItem>
        </ul>
    )
}

export default LifeYoung;